import classNames from "classnames";

const PageNumber = ({
  value,
  enabled = true,
  active,
  onClick,
}: {
  value: number;
  enabled?: boolean;
  active: boolean;
  onClick?: () => void;
}) => {
  return (
    <div className="tw:m-2" onClick={onClick}>
      <div
        className={classNames(
          "tw:flex tw:items-center tw:justify-center tw:bg-white tw:min-w-[1.75rem] tw:px-2 tw:h-7 tw:text-gray-700 tw:font-bold tw:!border tw:!rounded-full tw:!border-gray-300 tw:!border-opacity-30 tw:transition-colors hover:tw:bg-blue-500 hover:tw:text-white focus:tw:text-white",
          active && "tw:!bg-blue-500 hover:!tw:bg-blue-700 tw:text-white",
          !enabled && "tw:opacity-50 !tw:cursor-not-allowed",
        )}
      >
        {value}
      </div>
    </div>
  );
};

export const CarouselControlsNumbers = ({
  startingItem,
  currentItems,
  totalItems,
  onClick,
}: {
  startingItem: number;
  currentItems: number;
  totalItems: number;
  onClick?: (item: number) => void;
}) => {
  return (
    <div className="tw:flex tw:gap-2">
      <PageNumber
        value={startingItem + 1}
        active={currentItems === startingItem}
        onClick={() => onClick?.(startingItem)}
      />

      {totalItems > 2 && (
        <PageNumber
          value={startingItem + 2}
          active={currentItems === startingItem + 1}
          onClick={() => onClick?.(startingItem + 1)}
        />
      )}

      {totalItems > 3 && (
        <PageNumber
          value={startingItem + 3}
          active={currentItems === startingItem + 2}
          onClick={() => onClick?.(startingItem + 2)}
        />
      )}
    </div>
  );
};
